import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSettings } from '../../contexts/SettingsContext';

/** Rodapé legal das páginas de funil (/l/:slug e /a/:slug) — exigido pela revisão de anúncios do
 * Meta. Espelhado no snapshot SSR por backend/utils/legalFooter.js. */
const LegalFooter: React.FC<{ className?: string }> = ({ className = 'pb-8' }) => {
  const { t } = useTranslation();
  const { settings } = useSettings();

  const legal = settings?.site?.legal;
  const companyName = legal?.companyName || settings?.site?.name || '';
  const companyIds = [
    legal?.cnpj && `${t('landingPage.legalCnpj')} ${legal.cnpj}`,
    legal?.nif && `${t('landingPage.legalNif')} ${legal.nif}`
  ].filter(Boolean);
  const companyAddress = settings?.site?.contact?.address || '';

  return (
    <footer className={`bg-gray-50 border-t border-gray-200 pt-8 px-4 ${className}`}>
      <div className="container-custom max-w-3xl text-center text-xs text-gray-500 space-y-2">
        <p className="text-sm text-gray-600">{t('landingPage.visaDisclaimer')}</p>
        {(companyName || companyIds.length > 0) && (
          <p>{[companyName, ...companyIds].filter(Boolean).join(' · ')}</p>
        )}
        {companyAddress && <p>{companyAddress}</p>}
        <p className="flex justify-center gap-4">
          <Link to="/privacidade" target="_blank" rel="noopener noreferrer" className="underline hover:text-primary-600">
            {t('landingPage.privacy')}
          </Link>
          <Link to="/termos" target="_blank" rel="noopener noreferrer" className="underline hover:text-primary-600">
            {t('landingPage.terms')}
          </Link>
        </p>
      </div>
    </footer>
  );
};

export default LegalFooter;
